import React, { useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const PasswordField = ({
  type = "",
  className = "",
  placeholder = "",
  value = "",
  onChange = () => {},
  disabled = false,
  name = "",
  errors,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  return (
    <>
      <div>
        <InputGroup className="mb-3">
          <Form.Control
            aria-describedby="passwordHelpBlock"
            placeholder={placeholder}
            variant="outlined"
            type={showPassword ? "text" : "password"}
            className={`inputfield ${className}`}
            id={name}
            value={value}
            onChange={onChange}
            disabled={disabled}
            name={name}
          />

          <InputGroup.Text id="basic-addon2" onClick={togglePasswordVisibility}>
            {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
          </InputGroup.Text>
        </InputGroup>
      </div>
      <div className="d-flex">
        <div style={{ color: "red" }}>{errors}</div>
      </div>
    </>
  );
};

export default React.memo(PasswordField);
